module.exports = __webpack_public_path__ + "img/asus-zenfone-6-30-edition.6217af8d.jpg";